import type { ReferredVisitorPopupContent } from './types';

const DEFAULT_EXPLORE_HREF = '/music';
const EXPLORE_ROOTS = ['sfx', 'stock-video', 'motion-graphics', 'luts'];

export const getExploreHref = (asPath: string): string => {
  const [root] = asPath.split(/[/?#]/).filter(Boolean);
  return root && EXPLORE_ROOTS.includes(root)
    ? `/${root}`
    : DEFAULT_EXPLORE_HREF;
};

/** The creator's own heading and message, each overriding the default only when set. */
export const getCustomText = ({
  customSubjectLine,
  customMainText,
}: ReferredVisitorPopupContent) => ({
  ...(customSubjectLine && { title: customSubjectLine }),
  ...(customMainText && { description: customMainText }),
});
